import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as EleIcons from '@element-plus/icons-vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import '@/assets/global.css'
import "@/assets/base.css"
import '@/assets/icon/iconfont.css'
import '@/assets/js/flexible'
import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css
import 'amfe-flexible'
import ExamCore from '@edu-advance-exam/core'
import '@edu-advance-exam/core/dist/index.css'




// localStorage.clear();
const app = createApp(App)
app.config.globalProperties.$axios = axios;

const textStyle = {
  //中文字体
  fontFamily_Ch : '"Microsoft YaHei","微软雅黑",Arial',
  //英文字体
  fontFamily_En : 'Arial',
  //大号字一
  fontSize_Largest : '30px', 
  //大号字二
  fontSize_Large : '24px', 
  //主菜单文字
  fontSize_MainMenu : '18px',
  fontColor_MainMenu : '#333333',
  //子菜单文字
  fontSize_MenuItem : '16px',
  fontColor_MenuItem : '#666666',
  //标题文字
  fontSize_Title : '18px',
  fontColor_Title : '#333333',
  fontBold_Title : true,
  //正文文字
  fontSize_Text : '16px',
  fontColor_Text : '#333333',
  //输入框内提示文字
  fontSize_Place : '14px', 
  fontColor_Place : '#999999', //或者#cccccc
  //说明文字
  fontSize_Description : '14px',
  fontColor_Description : '#666666',
  //行间距(字体的倍数)
  lineSpaceMultiple : 1.5,
  //段落间距(字体的倍数)
  PartSpaceMultiple : 2.5,
  //按钮颜色深色
  buttonColor_Deep: '#556fb5',
  //按钮颜色浅色
  buttonColor_Light: '#8a9fda',
}

app.provide('textStyle',textStyle)

for(const name in EleIcons){
    app.component(name,EleIcons[name])
  }
app.use(vue3videoPlay)
app.use(ElementPlus).use(VueAxios,axios).use(router).use(ExamCore)
app.mount('#app')


